exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-main[data-v-72f3f6f0]{padding:0 .32rem}.sub_t[data-v-72f3f6f0]{font-size:.18rem;font-weight:bold}", ""]);

// exports
